import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const cols = [
    {
      title: "Learn",
      links: [
        { to: "/courses", label: "All Courses" },
        { to: "/learning-path", label: "Create Learning Path" },
        { to: "/pricing", label: "Pricing & Bundles" },
      ],
    },
    {
      title: "Company",
      links: [
        { to: "/about", label: "About Us" },
        { to: "/contact", label: "Contact" },
        { to: "/faq", label: "FAQ" },
      ],
    },
    {
      title: "Legal",
      links: [
        { to: "/terms", label: "Terms and Conditions" },
        { to: "/privacy", label: "Privacy Policy" },
        { to: "/refund", label: "Refund Policy" },
      ],
    },
  ];
  return (
    <footer className="border-t border-[#E5E7EB] bg-white mt-24">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src="/tmo-logo.png" alt="TeachMeOnline.ca" className="h-10 w-auto" />
          </div>
          <p className="text-sm text-[#4B5563] max-w-xs">
            Affordable, self-paced online learning for life and work in Canada.
          </p>
          <div className="mt-4 text-xs text-[#4B5563] space-y-1">
            <div className="label-eyebrow text-[#111827]">Office</div>
            <div>1212 31 Ave NE, unit 200<br/>Calgary, AB T2E 7S8</div>
            <div className="pt-2">
              <a href="mailto:info@teachmeonline.ca" className="hover:text-[#D92D20]">info@teachmeonline.ca</a>
              <span className="mx-1">|</span>
              <a href="mailto:teachmeonlineca@gmail.com" className="hover:text-[#D92D20]">teachmeonlineca@gmail.com</a>
            </div>
          </div>
          <p className="label-eyebrow mt-4">Made in Canada</p>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="font-display font-bold text-sm uppercase tracking-wider mb-3">{c.title}</h4>
            <ul className="space-y-2 text-sm text-[#4B5563]">
              {c.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`foot-${l.to.replace(/\//g, "-")}`} className="hover:text-[#D92D20]">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-6 py-4 text-xs text-[#4B5563] flex flex-col md:flex-row md:justify-between gap-2">
          <span>© {new Date().getFullYear()} TeachMeOnline.ca — All rights reserved.</span>
          <span>Educational courses only. Not accredited or government-approved.</span>
        </div>
      </div>
    </footer>
  );
}
